import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-edit",
  "use": "icon-cl-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-edit\"><path d=\"M3.333 12.667h.95L10.8 6.15l-.95-.95-6.517 6.517v.95ZM2 14v-2.833l8.8-8.784c.133-.122.28-.216.442-.283a1.38 1.38 0 0 1 1.025 0c.166.067.31.167.433.3l.917.933c.133.123.23.267.291.434a1.444 1.444 0 0 1 0 1.008 1.25 1.25 0 0 1-.291.442L4.833 14H2Zm8.317-8.317L9.85 5.2l.95.95-.483-.467Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol